import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuard,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { MSALGuardConfigFactory, MSALInstanceFactory } from './msal.config';
import { MsalAuthService } from './msal-auth.service';

@NgModule({
  imports: [MsalModule],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideAppInitializer(async () => {
      const msalAuthService = inject(MsalAuthService);
      const msalService = inject(MsalService);
      await firstValueFrom(msalService.initialize());
      await msalAuthService.restoreMsalCache();
    }),
  ],
})
export class CoreAuthModule {}
